class SimTestSuiteController {
    constructor($window, $location, $localStorage, $browser, $uibModal, ngProgressFactory, ModalService, toastr, moment, UtpUserTestSuitesServiceApi, UtpSimTestSuitesServiceApi, StateService, SettingsService, UserServiceApi
    // UserDetailsApi: IUserDetailsApi
    ) {
        this.$onInit = () => {
            this.userDetails = null;
            this.traceProgress = this.ngProgressFactory.createInstance();
            this.state = {
                debug: false,
                selectedTester: null,
                selectedSim: null,
                selectedSuite: null,
                editSuite: false,
                editTest: false,
                // Note: this.toggleTesters(true/false) is used to change this and get the data
                showExpiryIcons: false,
                visibleExpirys: '',
                expiryLimit: -1,
                DateFormats: {
                    DateTimeFormat: '',
                    DateFormat: '',
                    TimeFormat: ''
                },
                showTesters: true
            };
            this.data = {
                Sims: [{ Id: -1, Name: '' }],
                Testers: [{ Id: -1, Name: '' }],
                AvailableTestSuites: [{
                        ExpiryDate: null,
                        ExpiryClass: '',
                        ExpiryPopUpText: '',
                        Id: -1,
                        Name: '',
                        expired: false,
                        popupText: '',
                        statusColour: '',
                        TestCaseVariableCount: 0,
                        SupportsMultitest: true
                    }],
                ActiveTestCases: [{ Id: -1, Name: '', TruncatedNameMedium: '', TruncatedNameNarrow: '', TruncatedNameWide: '' }],
                ExcludedTestCases: [{ Id: -1, Name: '', TruncatedNameMedium: '', TruncatedNameNarrow: '', TruncatedNameWide: '' }],
                TestSuites: [{
                        ExpiryDate: null,
                        ExpiryClass: '',
                        ExpiryPopUpText: '',
                        Id: -1,
                        Name: '',
                        expired: false,
                        popupText: '',
                        statusColour: '',
                        TestCaseVariableCount: 0,
                        SupportsMultitest: true
                    }]
            };
            this.traceProgress.start();
            this.SettingsService.getSettings().then((response) => {
                let appSettings = response.data;
                this.state.DateFormats = {
                    DateTimeFormat: appSettings.DateTimeFormat,
                    DateFormat: appSettings.DateFormat,
                    TimeFormat: appSettings.TimeFormat
                };
                this.state.showExpiryIcons =
                    appSettings.TestSuiteExpirationVisibleClasses !== '';
                this.state.visibleExpirys =
                    appSettings.TestSuiteExpirationVisibleClasses;
                this.state.expiryLimit =
                    appSettings.TestSuiteExpiryWarningDayLimit;
            });
            this.UserServiceApi.details().then((response) => {
                this.userDetails = response.data; // setup our user details
                if (this.userDetails.IsAdmin) {
                    this.toggleTesters(false);
                    return;
                }
                if (this.userDetails.IsSupport) {
                    this.toggleTesters(true);
                    return;
                }
            }, () => {
                this.toastr.error('Please make sure that you are logged in to OTS UTP!');
                this.window.location.href = this.browser.baseHref() + 'account/login';
                return;
            });
        };
        this.generateStatusColor = (date) => {
            let colour = 'traffic-success';
            if (date !== undefined && date !== null) {
                let expiryMoment = this.moment(date);
                let today = this.moment();
                if (today.isAfter(expiryMoment)) {
                    colour = 'traffic-danger';
                }
                else if (expiryMoment.diff(today, 'days') < this.state.expiryLimit) {
                    colour = 'traffic-warning';
                }
            }
            return colour;
        };
        this.generatePopUp = (date) => {
            if (date === undefined || date === null) {
                return 'LIVE - No Expiry Date';
            }
            let expiryMoment = this.moment(date);
            let expiryDate = expiryMoment.format(this.state.DateFormats.DateFormat);
            let today = this.moment();
            let popupText = 'Will expire on ';
            if (today.isAfter(expiryMoment)) {
                popupText = 'Expired on ';
            }
            else if (expiryMoment.diff(today, 'days') < this.state.expiryLimit) {
                popupText = 'Expiring on ';
            }
            return popupText + expiryDate;
        };
        this.generateTestSuitePopups = () => {
            _.forEach(this.data.TestSuites, (suite) => {
                // if (suite.ExpiryDate != undefined && suite.ExpiryDate != null) {
                suite.popupText = this.generatePopUp(suite.ExpiryDate);
                suite.statusColour = this.generateStatusColor(suite.ExpiryDate);
                suite.expired = this.moment().isAfter(this.moment(suite.ExpiryDate));
                // }
            });
            _.forEach(this.data.AvailableTestSuites, (suite) => {
                // if (suite.ExpiryDate != undefined && suite.ExpiryDate != null) {
                suite.popupText = this.generatePopUp(suite.ExpiryDate);
                suite.statusColour = this.generateStatusColor(suite.ExpiryDate);
                suite.expired = this.moment().isAfter(this.moment(suite.ExpiryDate));
                // }
            });
        };
        this.addSimTestSuite = (sim, testSuite) => {
            let req = { SimId: sim.Id, TestSuiteId: testSuite.Id };
            this.SimTestSuiteService.addTestSuite(req).then((response) => {
                // Refresh the sim test suites lists
                this.data.TestSuites = response.data.TestSuites;
                this.data.AvailableTestSuites = response.data.AvailableTestSuites;
                this.generateTestSuitePopups();
                let suite = _.find(this.data.TestSuites, {
                    Id: testSuite.Id
                });
                this.selectSuite(suite);
            });
        };
        this.addUserTestSuite = (user, sim, testSuite) => {
            let req = {
                UserId: user.Id,
                SimId: sim.Id,
                TestSuiteId: testSuite.Id
            };
            this.UtpUserTestSuitesServiceApi.addTestSuite(req).then((response) => {
                // Refresh the user test suites lists
                this.data.TestSuites = response.data.TestSuites;
                this.data.AvailableTestSuites = response.data.AvailableTestSuites;
                this.generateTestSuitePopups();
                let suite = _.find(this.data.TestSuites, {
                    Id: testSuite.Id
                });
                this.selectSuite(suite);
            });
        };
        this.addTestSuite = (sim, testSuite) => {
            if (this.state.showTesters) {
                this.addUserTestSuite(this.state.selectedTester, sim, testSuite);
            }
            else {
                this.addSimTestSuite(sim, testSuite);
            }
            this.generateTestSuitePopups();
        };
        this.removeSimTestSuite = (sim, testSuite) => {
            let req = { SimId: sim.Id, TestSuiteId: testSuite.Id };
            this.SimTestSuiteService.removeTestSuite(req).then((response) => {
                // Refresh the test suites list
                this.data.TestSuites = response.data.TestSuites;
                this.data.AvailableTestSuites = response.data.AvailableTestSuites;
                this.generateTestSuitePopups();
                // Select the first in the list
                if (this.data.TestSuites.length > 0) {
                    this.selectSuite(this.data.TestSuites[0]);
                }
                else {
                    this.data.ActiveTestCases = [];
                }
            });
        };
        this.removeUserTestSuite = (user, sim, testSuite) => {
            let req = {
                UserId: user.Id,
                SimId: sim.Id,
                TestSuiteId: testSuite.Id
            };
            this.UtpUserTestSuitesServiceApi.removeTestSuite(req).then((response) => {
                // Refresh the test suites list
                this.data.TestSuites = response.data.TestSuites;
                this.data.AvailableTestSuites = response.data.AvailableTestSuites;
                this.generateTestSuitePopups();
                // Select the first in the list
                if (this.data.TestSuites.length > 0) {
                    this.selectSuite(this.data.TestSuites[0]);
                }
                else {
                    this.data.ActiveTestCases = [];
                }
            });
        };
        this.confirm = (item) => {
            // eg name = 'test suite something'
            let header = ['Remove ', item].join('');
            let msg = [''].join('');
            msg += [
                'All users who have been assigned this ',
                item,
                ' will be affected.'
            ].join('');
            let modalOptions = {
                actionButtonText: 'Yes',
                closeButtonText: 'No',
                headerText: header,
                bodyText: msg
            };
            return this.ModalService.showModal({}, modalOptions);
        };
        this.removeTestSuite = (sim, testSuite) => {
            if (this.state.showTesters) {
                this.removeUserTestSuite(this.state.selectedTester, sim, testSuite);
            }
            else {
                // Admin has to confirm as this will affect all testers
                this.confirm('Test Suite').then(() => {
                    this.removeSimTestSuite(sim, testSuite);
                });
            }
            this.generateTestSuitePopups();
        };
        this.addTestCase = (testCase) => {
            let sim = this.state.selectedSim;
            let testSuite = this.state.selectedSuite;
            if (this.state.showTesters) {
                let req = {
                    UserId: this.state.selectedTester.Id,
                    SimId: sim.Id,
                    TestSuiteId: testSuite.Id,
                    TestCaseId: testCase.Id
                };
                this.UtpUserTestSuitesServiceApi.addTestCase(req).then((response) => {
                    this.data.ActiveTestCases = response.data.ActiveTestCases;
                    this.data.ExcludedTestCases = response.data.ExcludedTestCases;
                });
            }
            else {
                let req = { SimId: sim.Id, TestSuiteId: testSuite.Id, TestCaseId: testCase.Id };
                this.SimTestSuiteService.addTestCase(req).then((response) => {
                    this.data.ActiveTestCases = response.data.ActiveTestCases;
                    this.data.ExcludedTestCases = response.data.ExcludedTestCases;
                });
            }
        };
        this.removeTestCase = (testCase) => {
            let sim = this.state.selectedSim;
            let testSuite = this.state.selectedSuite;
            if (this.state.showTesters) {
                let req = {
                    UserId: this.state.selectedTester.Id,
                    SimId: sim.Id,
                    TestSuiteId: testSuite.Id,
                    TestCaseId: testCase.Id
                };
                this.UtpUserTestSuitesServiceApi.removeTestCase(req).then((response) => {
                    this.data.ActiveTestCases = response.data.ActiveTestCases;
                    this.data.ExcludedTestCases = response.data.ExcludedTestCases;
                });
            }
            else {
                // Admin has to confirm as this will affect all testers
                this.confirm('Test Case').then(() => {
                    let req = { SimId: sim.Id, TestSuiteId: testSuite.Id, TestCaseId: testCase.Id };
                    this.SimTestSuiteService.removeTestCase(req).then((response) => {
                        this.data.ActiveTestCases = response.data.ActiveTestCases;
                        this.data.ExcludedTestCases =
                            response.data.ExcludedTestCases;
                    });
                });
            }
        };
        // Toggle between tester and sim views
        this.toggleTesters = (isShowTesters) => {
            // Reset the state
            this.state.showTesters = isShowTesters;
            this.state.editSuite = false;
            this.state.editTest = false;
            if (isShowTesters) {
                // Initialise the view model for the testers params are (userId, simId, suiteId)
                let data = { UserId: null, SimId: null, SuiteId: null, RestoreFullState: false, WithResults: false };
                this.UtpUserTestSuitesServiceApi.getUserModel(data).then((response) => {
                    this.data = response.data;
                    this.generateTestSuitePopups();
                    // TODO: Do we need to handle cases where there are no items
                    if (this.StateService.selectedTester.Id > 0) {
                        // OK We have a selected tester
                        let testerId = this.StateService.selectedTester.Id;
                        let tester = this.getItemById(this.data.Testers, testerId);
                        this.state.selectedTester = tester;
                        this.selectTester(tester);
                    }
                    else {
                        this.state.selectedTester = this.data.Testers[0];
                        this.state.selectedSim = this.data.Sims[0];
                        this.state.selectedSuite = this.data.TestSuites[0];
                    }
                });
            }
            else {
                // Initialise the view model for the sims
                this.SimTestSuiteService.getSimModel(null, null).then((response) => {
                    this.data = response.data;
                    this.generateTestSuitePopups();
                    this.state.selectedTester = null;
                    // TODO: Do we need to handle cases where there are no items
                    this.state.selectedSim = this.data.Sims[0];
                    this.state.selectedSuite = this.data.TestSuites[0];
                });
            }
        };
        this.getItemById = (collection, id) => {
            let ret = _.find(collection, ['Id', id]);
            return ret;
        };
        this.supportSelectedTester = () => {
            // Make sure we have a valid tester
            if (this.state.selectedTester === null ||
                this.state.selectedTester.Id === 0) {
                let msg = 'Invalid Tester: ' + this.state.selectedTester;
                this.toastr.warning(msg);
                return;
            }
            // Store the selected tester in the state service
            this.StateService.selectedTester = this.state.selectedTester;
            // If this is a ManagedTester then we go somewhere else
            this.UserServiceApi.getUser(this.state.selectedTester.Id).then((response) => {
                let tester = response.data;
                if (tester.IsGroupTester) {
                    let gtRoute = '/GtHome/' + tester.Id;
                    this.location.path(gtRoute);
                    return;
                }
                if (tester.IsDataValidator) {
                    let dvRoute = '/DataValidator/' + tester.Id;
                    this.location.path(dvRoute);
                    return;
                }
                let route = '/Home/' + this.state.selectedTester.Id;
                this.location.path(route);
            });
        };
        // Populate view model with new data
        this.populateModel = (tester, sim, suite, newData) => {
            // Populate the model in order of Tests, Suites, then Sims
            // If we select a suite then just populate the tests
            if (suite !== null) {
                // Test Cases
                this.data.ActiveTestCases = newData.ActiveTestCases;
                this.data.ExcludedTestCases = newData.ExcludedTestCases;
                /// State
                this.state.selectedSuite = suite;
                return;
            }
            // If we select a sim then populate the suites and tests
            if (sim !== null) {
                // Test Suites
                this.data.TestSuites = newData.TestSuites;
                this.data.AvailableTestSuites = newData.AvailableTestSuites;
                this.generateTestSuitePopups();
                // Test Cases
                this.data.ActiveTestCases = newData.ActiveTestCases;
                this.data.ExcludedTestCases = newData.ExcludedTestCases;
                // State
                this.state.selectedSim = sim;
                // TODO: Check that we have at least one test suite
                if (newData.TestSuites.length > 0) {
                    this.state.selectedSuite = newData.TestSuites[0];
                }
                else {
                    this.data.ActiveTestCases = null;
                }
                return;
            }
            // If we select a tester then populate the sims, suites, and tests
            if (tester !== null) {
                // Sims
                this.data.Sims = newData.Sims;
                // Test Suites
                this.data.TestSuites = newData.TestSuites;
                this.data.AvailableTestSuites = newData.AvailableTestSuites;
                this.generateTestSuitePopups();
                // Test Cases
                this.data.ActiveTestCases = newData.ActiveTestCases;
                this.data.ExcludedTestCases = newData.ExcludedTestCases;
                // State
                this.state.selectedTester = tester;
                if (newData.Sims.length > 0) {
                    this.state.selectedSim = newData.Sims[0];
                }
                if (newData.TestSuites.length > 0) {
                    this.state.selectedSuite = newData.TestSuites[0];
                }
                return;
            }
        };
        // Select Tester/Sim/Suite
        this.selectTester = (tester) => {
            this.traceProgress.start();
            let data = { UserId: tester.Id, SimId: null, SuiteId: null, RestoreFullState: false, WithResults: false };
            this.UtpUserTestSuitesServiceApi.getUserModel(data).then((response) => {
                this.traceProgress.complete();
                this.populateModel(tester, null, null, response.data);
            });
        };
        this.selectSim = (sim) => {
            this.state.selectedSim = sim;
            if (this.state.showTesters) {
                let tester = this.state.selectedTester;
                let data = { UserId: tester.Id, SimId: sim.Id, SuiteId: null, RestoreFullState: false, WithResults: false };
                this.UtpUserTestSuitesServiceApi.getUserModel(data).then((response) => {
                    this.populateModel(tester, sim, null, response.data);
                });
            }
            else {
                this.SimTestSuiteService.getSimModel(sim.Id, null).then((response) => {
                    this.populateModel(null, sim, null, response.data);
                });
            }
        };
        this.selectSuite = (suite) => {
            let tester = this.state.selectedTester;
            let sim = this.state.selectedSim;
            if (this.state.showTesters) {
                let data = { UserId: tester.Id, SimId: sim.Id, SuiteId: suite.Id, RestoreFullState: false, WithResults: false };
                this.UtpUserTestSuitesServiceApi.getUserModel(data).then((response) => {
                    this.populateModel(tester, sim, suite, response.data);
                });
            }
            else {
                this.SimTestSuiteService.getSimModel(sim.Id, suite.Id).then((response) => {
                    this.populateModel(null, sim, suite, response.data);
                });
            }
        };
        // ShowEditTest modal
        this.showEditTest = () => {
            let modalInstance = this.uibModal.open({
                animation: true,
                component: 'uploadTestCasesModal',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    selectedItems: () => {
                        return {
                            selectedTester: this.state.selectedTester,
                            selectedSim: this.state.selectedSim,
                            selectedSuite: this.state.selectedSuite,
                            testCases: this.data.ActiveTestCases,
                            excludedTestCases: this.data.ExcludedTestCases,
                            showTesters: this.state.showTesters
                        };
                    }
                }
            });
            modalInstance.result.then((result) => {
                // Assign returned data to active and excluded test cases
                this.data.ActiveTestCases = result.ActiveTestCases;
                this.data.ExcludedTestCases = result.ExcludedTestCases;
                return;
            });
        };
        // END ShowEditTest modal
        // Edit Test case instructions
        this.editTestInstructions = (paramSuite) => {
            // Transform the IdName to the suite interface
            let suite = {};
            suite.Id = paramSuite.Id;
            suite.TestSuiteName = paramSuite.Name;
            suite.expiryClass = paramSuite.ExpiryClass;
            let suiteEditModal = this.uibModal.open({
                backdrop: 'static',
                animation: true,
                component: 'editTestCaseComponent',
                size: 'md',
                resolve: {
                    suite: () => {
                        return suite;
                    },
                    visibleExpirys: () => {
                        return this.state.visibleExpirys;
                    }
                }
            });
            suiteEditModal.result.then(() => {
                // TODO: Refresh test cases with TestInfo interface
                // TODO: We need to add a service call and change the test cases display
            });
        };
        this.window = $window;
        this.location = $location;
        this.localStorage = $localStorage;
        this.browser = $browser;
        this.uibModal = $uibModal;
        this.ngProgressFactory = ngProgressFactory;
        this.ModalService = ModalService;
        this.toastr = toastr;
        this.moment = moment;
        this.UtpUserTestSuitesServiceApi = UtpUserTestSuitesServiceApi;
        this.SimTestSuiteService = UtpSimTestSuitesServiceApi;
        this.StateService = StateService;
        this.SettingsService = SettingsService;
        this.UserServiceApi = UserServiceApi;
    }
}
angular.module('app').component('simTestSuites', {
    templateUrl: 'Scripts/App/partials/ProvisionSim/sim-test-suites.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: SimTestSuiteController
});
